/* is-sticky */
document.addEventListener("scroll", function () {
  const el = document.querySelector(".Featured_inner_new");
  if (!el) return;

  const rect = el.getBoundingClientRect();

  const isSticky = rect.top <= 0;
  const isInViewport = rect.bottom > 0 && rect.top < window.innerHeight;

  if (isSticky && isInViewport) {
    document.body.classList.add("is-sticky");
  } else {
    document.body.classList.remove("is-sticky");
  }
});